import { Search, X } from 'lucide-react';
import type { Ref } from 'react';
import { Icon } from '../Icon/Icon';
import { TextInput, type TextInputProps } from '../TextInput/TextInput';
import s from './SearchInput.module.css';

export type SearchInputProps = Omit<
  TextInputProps,
  'type' | 'prefix' | 'suffix' | 'onChange' | 'value'
> & {
  ref?: Ref<HTMLInputElement>;
  value: string;
  onValueChange: (value: string) => void;
};

export function SearchInput({
  value,
  onValueChange,
  placeholder = 'Search',
  ...rest
}: SearchInputProps) {
  return (
    <TextInput
      type="search"
      inputMode="search"
      enterKeyHint="search"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onValueChange(e.currentTarget.value)}
      prefix={<Icon icon={Search} size="md" />}
      suffix={
        value ? (
          <button
            type="button"
            className={s.clear}
            aria-label="Clear search"
            onClick={() => onValueChange('')}
          >
            <Icon icon={X} size="md" />
          </button>
        ) : null
      }
      {...rest}
    />
  );
}
